"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postSyncOrganizationSecurityAlerts = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.postSyncOrganizationSecurityAlerts = (0, sonar_http_1.createPostEndpoint)('/api/v3/demo/dreamforce/create-metrics');
//# sourceMappingURL=postSyncOrganizationSecurityAlerts.js.map